import { render, staticRenderFns } from "./gradient-picker.vue?vue&type=template&id=0c859970&scoped=true&"
import script from "./gradient-picker.vue?vue&type=script&lang=js&"
export * from "./gradient-picker.vue?vue&type=script&lang=js&"
import style0 from "./gradient-picker.vue?vue&type=style&index=0&id=0c859970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c859970",
  null
  
)

export default component.exports